export default __webpack_public_path__ + "static/media/flag-hawaii.aa970b5a.svg";